
import { StateCreator } from 'zustand';
import { GridFilters, GridSellerClosetSlice } from '../gridTypes';
import { setFilterPropertyHandler } from '../gridUtils';

type ImmerStateCreator<T> = StateCreator<
  T,
  [["zustand/immer", never], never],
  [],
  T
>;

const initialState: GridFilters = {
    sort: 'sortOrder',
    conditionFilter: [],
    sizeFilter: [],
    minPrice: undefined,
    maxPrice: undefined,
    isInitialState: true,
    groupId: undefined,
    customerStoreId:undefined,
    shippingTypeId:[],
    pageSize: undefined,
    sellerId: undefined,
    cartCode: undefined,
    categoryId: undefined,
    excludeProductId: undefined,
}


export const createGridSellerClosetSlice: ImmerStateCreator<GridSellerClosetSlice> = (set) => ({
    gridSellerClosetFilters: initialState,
    SET_SELLER_CLOSET_FILTER: (filterType, newValue) => {
        set((state) => {
            const  { gridSellerClosetFilters } = state
            const filterUpdated = setFilterPropertyHandler(gridSellerClosetFilters, filterType, newValue)
            state.gridSellerClosetFilters = {...filterUpdated, isInitialState: false}
        }, false, 'SET_SELLER_CLOSET_FILTER')
    },
    SET_SELLER_CLOSET_ALL_FILTER: (initialFilterBundles) => {
        set((state) => {
            state.gridSellerClosetFilters = {...initialFilterBundles, isInitialState: false}
        }, false, 'SET_SELLER_CLOSET_ALL_FILTER')
    },
    RESET_SELLER_CLOSET_FILTER: () => {
        set((state) => {
            state.gridSellerClosetFilters = {...state.gridSellerClosetFilters, ...initialState}
        }, false, 'RESET_SELLER_CLOSET_FILTER')
    },
});

